/**
 * Re-exports CI threshold functions from the shared package.
 * Single source of truth: packages/shared/continuousImprovement/index.js
 *
 * Rapid must import via the barrel due to Vite/ESM constraints with CJS subpath imports.
 */
import { continuousImprovement } from "@rflocal/shared";

export const { getNextThreshold, getPreviousThreshold, didCrossThreshold } = continuousImprovement;
